import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../filesApi';

function* setSalesDocumentPermissionSaga(action: ReturnType<typeof filesActionCreators.setSalesDocumentPermissions>) {
  yield put(uiActionCreators.showSpinnerDialog());

  try {
    const response = yield* call(api.setSalesDocumentPermissions, action.payload);

    if (response.value) {
      yield put(filesActionCreators.setFiles(response.value));
    }

    yield processMessages(response);
  } catch {
    //
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSetSalesDocumentPermission() {
  yield takeEvery(filesActionCreators.setSalesDocumentPermissions.match, setSalesDocumentPermissionSaga);
}
